module.exports = __webpack_public_path__ + "img/retail03.f48b2983.png";